function useColorStyle(key: string | null, prefix: string | null = null)
{
	if (key)
	{
		if (prefix)
		{
			key = prefix + key;
		}

		return {
			"--color": "var(--color-" + key + ")",
			"--dark-color": "var(--color-" + key + "-alt)",
		};
	}

	return null;
}

/** Mapping des 7 couleurs prédéfinies CFL → hex (light + dark = -alt). Utile pour les libs
 *  externes qui n'ont pas accès aux CSS variables (ex : Leaflet polyline). Valeurs copiées
 *  depuis shared/css/color.css. */
const CFL_PALETTE_HEX: Record<string, { light: string, dark: string }> = {
	"vert-de-hooker":    { light: "#53796f", dark: "#669186" },
	"rouge-auburn":      { light: "#AB3B3A", dark: "#D66665" },
	"bleu-ceruleen":     { light: "#19759F", dark: "#5899C3" },
	"jaune-jasmine":     { light: "#876407", dark: "#E9C46A" },
	"violet-prune":      { light: "#7e2e84", dark: "#BA6AC0" },
	"marron-sepia":      { light: "#6D584C", dark: "#998478" },
	"orange-mandarine":  { light: "#A85229", dark: "#F6976E" },
	"magenta-brume":     { light: "#A73D72", dark: "#CE6499" },
	"vert-success":      { light: "#1A8754", dark: "#06B637" },
	"gris":              { light: "#64748b", dark: "#94a3b8" },
};

/** Un alias suffixé `-alt` force la variante "dark" (theme-independent). Sans suffixe, on
 *  retombe sur la dépendance au thème courant. Permet de stocker une couleur visuelle figée
 *  pour les tracés Leaflet (qui se lisent pareil light + dark). */
function resolveCflHex(alias: string | null | undefined, isDark: boolean = false): string | null
{
	if (! alias) return null;
	if (alias.endsWith("-alt"))
	{
		return CFL_PALETTE_HEX[alias.slice(0, -4)]?.dark ?? null;
	}
	const entry = CFL_PALETTE_HEX[alias];
	if (! entry) return null;
	return isDark ? entry.dark : entry.light;
}

export {
	useColorStyle,
	resolveCflHex,
	CFL_PALETTE_HEX,
};
